import styled from "@emotion/styled";

export const Button = styled.a`
  width: 100%;
  margin-block-start: 30px;

  > svg {
    flex-shrink: 0;
  }
`;
